export const SettingConstant = {
  COMPANY_LOGO_KEY: 'company_logo',
  INVENTORY_PICK_AND_PACK: 'inventory_pick_and_pack_items',
};
